import { MouseEvent, useCallback } from "react";

import CallEndIcon from "@mui/icons-material/CallEnd";
import PhoneIcon from "@mui/icons-material/Phone";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import useTheme from "@mui/material/styles/useTheme";

import { error, primary } from "app/themes/colors";
import useSunoDialer from "components/suno-dialer/use-suno-dialer.hook";
import { useCallContext } from "hooks/use-twilio-call-context";

export default function ActionButtonsBlock() {
  const theme = useTheme();
  const { currentCall } = useCallContext();
  const { handleDismissCall, handlePickUpCall, incomingCall, isExpanded } =
    useSunoDialer();

  const handleAnswerCallClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      handlePickUpCall(String(currentCall?.parameters.CallSid), currentCall);
    },
    [currentCall, handlePickUpCall]
  );

  const handleDismissCallClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      handleDismissCall(String(incomingCall?.id));
    },
    [handleDismissCall, incomingCall]
  );

  return (
    <Box sx={{ p: 2, mt: isExpanded ? 0 : -1.5, pb: isExpanded ? 1.5 : 0.5 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        spacing={1}
        sx={{
          background: isExpanded ? "hsla(9, 0%, 100%, 0.7)" : undefined,
          p: 1.5,
          py: isExpanded ? undefined : 0.5,
          px: isExpanded ? undefined : 0,
          borderRadius: "16px",
          boxShadow: isExpanded ? theme.shadows[3] : undefined
        }}
      >
        <Button
          variant="contained"
          size="small"
          sx={{
            textTransform: "none",
            background: `${primary[400]} !important`,
            transform: isExpanded ? undefined : "scale(0.85)",
            "&:hover": {
              background: `${primary[500]} !important`,
              transform: isExpanded ? "scale(1.05)" : "scale(0.9)"
            }
          }}
          onClick={handleAnswerCallClick}
        >
          <PhoneIcon
            sx={{ pr: 1, transform: isExpanded ? undefined : "scale(0.8)" }}
          />{" "}
          Answer
        </Button>
        <Button
          variant="contained"
          size="small"
          sx={{
            textTransform: "none",
            background: `${error[700]} !important`,
            transform: isExpanded ? undefined : "scale(0.85)",

            "&:hover": {
              background: `${error[800]} !important`,
              color: `white !important`,
              transform: isExpanded ? "scale(1.05)" : "scale(0.9)"
            }
          }}
          onClick={handleDismissCallClick}
        >
          <CallEndIcon
            sx={{ pr: 1, transform: isExpanded ? undefined : "scale(0.8)" }}
          />{" "}
          Dismiss
        </Button>
      </Stack>
    </Box>
  );
}
